/**
 * TanStack Query hooks for `gdpr-regional-data-storage-dsr-endpoints-ui-http-api`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	gdprRegionalDataStorageDsrEndpointsUiHttpApiQueryKeys,
	type CreateGdprRegionalDataStorageDsrEndpointsUiHttpApiBody,
	type ListGdprRegionalDataStorageDsrEndpointsUiHttpApiResponse,
	type GdprRegionalDataStorageDsrEndpointsUiHttpApiRow,
} from "./api";

export function useGdprRegionalDataStorageDsrEndpointsUiHttpApiList(): UseQueryResult<ListGdprRegionalDataStorageDsrEndpointsUiHttpApiResponse, Error> {
	return useQuery({
		queryKey: gdprRegionalDataStorageDsrEndpointsUiHttpApiQueryKeys.list(),
		queryFn: list,
	});
}

export function useGdprRegionalDataStorageDsrEndpointsUiHttpApiCreate(): UseMutationResult<GdprRegionalDataStorageDsrEndpointsUiHttpApiRow, Error, CreateGdprRegionalDataStorageDsrEndpointsUiHttpApiBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gdprRegionalDataStorageDsrEndpointsUiHttpApiQueryKeys.all });
		},
	});
}

export function useGdprRegionalDataStorageDsrEndpointsUiHttpApiDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: gdprRegionalDataStorageDsrEndpointsUiHttpApiQueryKeys.all });
		},
	});
}
